import React from "react";
import "./NotificationCard.scss";
import { Danger, WarningIcon } from "../ui/icons";
import { B1, B2 } from "../ui/Typography";

const NotificationCard = ({ type, title, id, time }) => {
  // Choose icon based on type
  const Icon =
    type?.toLowerCase() === "warning"
      ? WarningIcon
      : type?.toLowerCase() === "danger"
      ? Danger
      : null;
  return (
    <div className={`borderWrapper w-100 notification-block ${type}`}>
      <div className="borderInner">
        <div className="notification-container-box">
          <div className="heading">
            {Icon && <Icon size={20} className={`heading-icon ${type}`} />}
            <B1>{title}</B1>
          </div>
          <div className="details">
            <B2 className="id">{id}</B2>
            <B2 className="time">{time}</B2>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotificationCard;
